<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: "chart",
  data() {
    return {
      list: [], //聊天记录的数组
      contentText: "", //input输入的值
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      otherInfo: {},
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.initView();
    var that = this;
    layui.use(
      ["form", "layer", "table", "laytpl", "element", "layim"],
      function () {
        var form = layui.form,
          layer = parent.layer === undefined ? layui.layer : top.layer,
          $ = layui.jquery,
          laytpl = layui.laytpl,
          table = layui.table,
          element = layui.element,
          layim = layui.layim;
debugger
        //声明对象npm
        var MyMethod = function () {};
        MyMethod.prototype = {
          openSocket: function (userId) {
            if (typeof WebSocket == "undefined") {
              console.log("您的浏览器不支持WebSocket");
            } else {
              console.log("您的浏览器支持WebSocket");

              /*var socketUrl="http://localhost:8080/websocket/"+userId;*/
              // var socketUrl="http://shop.hk952183.com/websocket/"+userId;
              var socketUrl =
                "http://192.168.31.113:8081/websocket/" + that.userInfo.id;
              // "http://47.96.28.227:8081/websocket/" + that.userInfo.id;
              socketUrl = socketUrl
                .replace("https", "ws")
                .replace("http", "ws");

              // if (socket != null) {
              //   // socket.close();
              //   socket = null;
              // }
              socket = new WebSocket(socketUrl);
              socket.onopen = function () {
                console.log("websocket已打开");
              };
              // debugger;
              socket.onmessage = function (res) {
                if (res.data === "连接成功") {
                } else {
                  var obj = JSON.parse(res.data);
                  if (obj.emit === "privateChart") {
                    layim.getMessage(obj.data);
                  }
                }
              };

              socket.onclose = function () {
                console.log("websocket已关闭");
              };

              socket.onerror = function () {
                console.log("websocket发生错误");
              };
            }
          },
          getUserById: function (id) {
            let mine = null;
            mine = {
              username: that.userInfo.username,
              id: that.userInfo.id,
              status: "online",
              avatar: that.userInfo.avatar,
            };

            return mine;
          },
        };

        var my = new MyMethod();
        var socket;
        layim.on("sendMessage", function (res) {
          var mine = res.mine;
          var to = res.to;
          socket.send(
            JSON.stringify({
              type: "privateChart",
              data: res,
            })
          );
        });
         form.on('submit(save)',function(data){

        my.openSocket(1);

        let UserMine = my.getUserById(that.userInfo.id);
        let myInfo = {
          username: that.userInfo.username,
          id: that.userInfo.id,
          status: "online",
          avatar: that.userInfo.avatar,
        };
        let UserTo = my.getUserById(1);
        let toInfo = {
          name: "admin",
          type: "friend",
          avatar: that.userInfo.avatar,
          id: 1,
        };
        layim.config({
            init: {
              mine: myInfo,
            },
            brief: true,
          })
          .chat({
            name: that.otherInfo.callName,
            type: "friend",
            /* ,avatar: 'http://localhost:8080/upload/SYSTEM/xiaoxin.jpg'*/
            avatar:
              "https://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/upload/SYSTEM/xiaoxin.jpg",
            id: that.otherInfo.id,
          });

         })
      }
    );
  },
  methods: {
    initView() {
      this.$axios.get("/gw/zone/infoByParam").then((res) => {
        this.otherInfo = res.data.data;
      });
    },
  },
};
</script>

<style scoped>
</style>
